import { Component, OnInit, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import * as _ from 'lodash';

import { TreatmentModel, TreatmentStoreModel } from './treatment.model';

import { State } from '../../reducers/index';
import { OVERLAY_START, SHOW_HEADER } from '../../actions/header.action';
import { Data, DATA_REQUEST } from '../../actions/data.action';
import { INFO_UPDATE } from '../../actions/info.action';
import { Booking } from '../../actions/booking.action';

@Component({
  selector: 'consentz-treatment',
  templateUrl: './treatment.template.html',
  styleUrls: ['./treatment.styles.scss'],
})
export class TreatmentComponent implements OnInit, OnDestroy {
  public model: TreatmentModel = new TreatmentModel(
    JSON.parse(localStorage.getItem('currentBookingOptions')),
    localStorage.getItem('AppId') ? localStorage.getItem('AppId') : window.location.hash.split('/')[1]
  );
  public dataStore: TreatmentStoreModel = new TreatmentStoreModel();

  constructor(
    private router: Router,
    private store: Store<State>
  ) {
    // hide header, allow ovelay, get treatments request
    this.store.dispatch({ type: SHOW_HEADER });
    this.store.dispatch({ type: OVERLAY_START });
    this.store.dispatch({
      type: DATA_REQUEST,
      payload: {
        requestUrl: `/online-booking/${localStorage.getItem('clinicId')}/treatments`
      }
    });
    // subscribtion on widget options, server data, local selections
    this.dataStore.subscribtion.booking$ = store.select<any>('booking').subscribe((data: Booking) => {
      if (Object.keys(data).find(key => key === 'primaryFontColour')) {
        this.model.currentBookingOptions = data;
      }
    });
    this.dataStore.model$ = store.select<any>('data').subscribe((data) => {
      const practitioners = {};
      if (data.treatments && data.treatments.length) {
        this.model.treatmentList = _.orderBy(data.treatments.map(treatment => {
          if (treatment.prices.find(price => price.length > -1)) {
            treatment.prices = treatment.prices.reduce((a, b) => a.concat(b));
          }
          return treatment;
        }), 'name');
      }
      this.model.treatmentList.forEach((treatment) => {
        treatment.prices.forEach((price) => {
          if (price.practitionerId) {
            !practitioners[treatment.id] ? practitioners[treatment.id] = price.practitionerId + '' : practitioners[treatment.id] += price.practitionerId;
          }
        });
      });
      localStorage.setItem('treatmentPractitioners', JSON.stringify(practitioners));
      // add permission for each treatment and price -> show/hide full version
      if (this.model.treatments.length !== this.model.treatmentList.length) {
        this.model.treatmentList.forEach((treatment: any, index: number) => {
          this.model.treatments[index] = {
            status: false,
            prices: treatment.prices.map(treatmentPrice => false)
          };
        });
      }
    });
    this.dataStore.subscribtion.data$ = store.select<any>('info').subscribe((data: Data) => {
      if (data['price'] && data['price'].practitionerId) {
        localStorage.setItem('goToTreatment', 'treatment');
        this.model.practitioner = true;
      }
    });

    this.dataStore.info$ = store.select<any>('info');
  }
  // detect window size
  public sizeOfScreen(): number {
    return window.innerHeight;
  }
  // add treatment and price to store
  public selectTreatment(event: any, treatment: any, index: number, price: any, indexPrice: number): void {
    event.stopPropagation();
    this.model.indexOfChosenTreatment = null;
    this.model.indexOfChosenPrice = null;
    localStorage.removeItem('treatmentId');
    localStorage.removeItem('treatmentTime');
    this.model.practitioner = false;
    localStorage.removeItem('practitionerId');
    localStorage.removeItem('goToTreatment');
    if (this.model.indexOfChosenPrice === indexPrice && this.model.indexOfChosenTreatment === index) {
      this.store.dispatch({
        type: INFO_UPDATE,
        payload: {
          treatment: null,
          price: null,
          practitioner: null
        }
      });
    } else {
      this.model.indexOfChosenTreatment = index;
      this.model.indexOfChosenPrice = indexPrice;
      localStorage.setItem('treatmentId', treatment.id);
      localStorage.setItem('treatmentTime', treatment.defaultLength);
      if (price.practitionerId) {
        this.model.practitioner = true;
        localStorage.setItem('practitionerId', price.practitionerId);
        localStorage.setItem('goToTreatment', 'treatment');
        this.store.dispatch({
          type: DATA_REQUEST,
          payload: {
            requestUrl: `/online-booking/${localStorage.getItem('practitionerId')}/week`
          }
        });
        this.store.dispatch({
          type: INFO_UPDATE,
          payload: {
            treatment: treatment,
            price: price,
            practitioner: { id: price.practitionerId }
          }
        });
      } else {
        this.store.dispatch({
          type: INFO_UPDATE,
          payload: {
            treatment: treatment,
            price: price
          }
        });
      }
    }
  }
  // show full treatment
  public showMore(index: number, $event, treatment, treatmentIndex, price, priceIndex): void {
    if (this.model.treatments[index].prices.length) {
      this.model.treatments[index].status = !this.model.treatments[index].status;
      if (this.model.treatments[index].prices.length === 1 && this.model.treatments[index].status) {
        this.selectTreatment($event, treatment, treatmentIndex, price, priceIndex);
      }
    }
    this.setDynamicColor();
  }

  public ngOnInit(): void {
    this.setDynamicColor();
  }
  // unsubscribe from store
  public ngOnDestroy(): void {
    this.dataStore.subscribtion.data$.unsubscribe();
    this.dataStore.subscribtion.booking$.unsubscribe();
  }
  // set dynamic color for interface
  private setDynamicColor(): void {
    let style: any = null;
    if (document.querySelector('#css-dynamic-class')) {
      style = document.querySelector('#css-dynamic-class');
    } else {
      style = document.createElement('style');
      style.type = 'text/css';
      style.id = 'css-dynamic-class';
    }
    style.innerHTML = `.css-dynamic-class { background-color: ${this.model.currentBookingOptions.secondaryInterfaceColour}!important; }`;
    document.getElementsByTagName('head')[0].appendChild(style);

    const element: any = document.querySelector('.ui-scrollpanel-bar-y');
    element.classList.add('css-dynamic-class');
  }
}



// WEBPACK FOOTER //
// /Users/dtrubetskoi/Desktop/projects/online-booking-widget/src/app/components/treatment/treatment.component.ts